<h2 mat-dialog-title>Confirmación</h2>
    <mat-dialog-content>{{ data.message }}</mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()"  color="warn">Cancelar</button>
      <button mat-raised-button color="primary" (click)="onConfirm()">Aceptar</button>
    </mat-dialog-actions>